import { QrvType } from '@marriott/shared/mi-helper-utils';

export interface AccountModalEvent {
  modalType: string;
  randParameter?: string;
  enrollmentSourceCode?: string;
  signInReturnUrl?: string;
  successEvent?: string;
  ocjCallbackEvent?: string;
  subDirectoryPrefix?: string;
  isSwap?: boolean;
  isRemembered?: boolean;
  ocjCustomClickTrack?: string;
  modalId?: string;
  flyoutType?: string;
  qrvVariation?: QrvType;
  newApproach?: boolean;
  isGlobalHeaderSignIn?: boolean;
  trackingPageName?: string;
  flyoutOpenReason?: string;
  action?: string;
  propertyId?: string;
  isBookFlow?: boolean;
  joinNowCtaPath?: string;
}

export const ACCOUNT_MODAL_OPEN_EVENT = 'accountModalOpen';
export const ACCOUNT_MODAL_CLOSE_EVENT = 'accountModalClose';
export enum FLYOUT_DRAWER_EVENTS {
  OPEN = 'OPEN_DRAWER',
  close = 'CLOSE_DRAWER',
}

export enum ACCOUNT_MODAL_VARIATION {
  DEFAULT = 'DEFAULT',
  RESERVATION = 'RESERVATION',
}
